var React = require('react');

function Folder (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fillRule":"nonzero","stroke":"currentColor","strokeWidth":"2.5","d":"M8.724 3.818L7.828 2h-4.93A.9.9 0 0 0 2 2.905v8.19c0 .5.403.905.894.905h11.212a.9.9 0 0 0 .894-.907V4.725c0-.5-.402-.907-.9-.907H8.725z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M3 3.1h11v2H3z","key":1})]));
}

Folder.defaultProps = {"width":"17","height":"14","viewBox":"0 0 17 14"};

module.exports = Folder;

Folder.default = Folder;
